// The stored attribute value is a lowercase slug derived from the human label
// ("Chump Off" -> "chump-off") — matches the existing dictionary vocabulary
// (bone-in, skin-off, ...). The label is what users see; the slug is the
// immutable identifier products reference.
export function slugifyAttributeValue(label: string): string {
  return label
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
